import React, {FC} from 'react';
import {Checkbox, CircularProgress, FormControlLabel, makeStyles, Typography} from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
    container: {
        /*display: 'flex',
        alignItems: 'center'*/
    }
}));

interface BilledCheckboxProps {
    confirmed?: boolean;
    onChange: (confirmed: boolean) => Promise<any>;
    className?: string
}

export const ConfirmedCheckbox: FC<BilledCheckboxProps> = ({confirmed, onChange, className}) => {
    const classes = useStyles();
    const [isLoading, setIsLoading] = React.useState(false);
    return (
        <div className={clsx(className, classes.container)}>
            <Typography variant="caption" color="textSecondary">
                Bestätigt
            </Typography>
            <div>
                <FormControlLabel
                    control={
                        <React.Fragment>
                            {isLoading
                                ? <CircularProgress/>
                                : (<Checkbox
                                    color="primary"
                                    checked={Boolean(confirmed)}
                                    onChange={(_e, checked) => {
                                        setIsLoading(true);
                                        onChange(checked)
                                            .catch(() => {
                                            })
                                            .finally(() => setIsLoading(false));
                                    }}
                                />)}
                        </React.Fragment>
                    }
                    label={<Typography variant="body1">Bestätigt</Typography>}
                />
            </div>
        </div>
    )
}
